var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 65,
    viewBox: "0 0 59 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1396_5040)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4082 5C10.9736 5 9 6.97361 9 9.40817V41.7347C9 44.1693 10.9736 46.1429 13.4082 46.1429H25.6125L27.6626 49.6939C28.511 51.1633 30.6319 51.1633 31.4802 49.6939L33.5304 46.1429H45.7347C48.1693 46.1429 50.1429 44.1693 50.1429 41.7347V9.40816C50.1429 6.9736 48.1692 5 45.7347 5H13.4082Z",
    fill: "#00B0C8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1396_5040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1429 24.8571V30.5714C18.1429 31.7571 19.1 32.7142 20.2857 32.7142C21.4714 32.7142 22.4286 31.7571 22.4286 30.5714V24.8571C22.4286 23.6714 21.4714 22.7142 20.2857 22.7142C19.1 22.7142 18.1429 23.6714 18.1429 24.8571ZM26.7143 24.8571V30.5714C26.7143 31.7571 27.6714 32.7142 28.8571 32.7142C30.0429 32.7142 31 31.7571 31 30.5714V24.8571C31 23.6714 30.0429 22.7142 28.8571 22.7142C27.6714 22.7142 26.7143 23.6714 26.7143 24.8571ZM17.4286 39.8571H40.2857C41.4714 39.8571 42.4286 38.8999 42.4286 37.7142C42.4286 36.5285 41.4714 35.5714 40.2857 35.5714H17.4286C16.2429 35.5714 15.2857 36.5285 15.2857 37.7142C15.2857 38.8999 16.2429 39.8571 17.4286 39.8571ZM35.2857 24.8571V30.5714C35.2857 31.7571 36.2429 32.7142 37.4286 32.7142C38.6143 32.7142 39.5714 31.7571 39.5714 30.5714V24.8571C39.5714 23.6714 38.6143 22.7142 37.4286 22.7142C36.2429 22.7142 35.2857 23.6714 35.2857 24.8571ZM27.5286 10.5571L16.2429 16.4999C15.6571 16.7999 15.2857 17.4142 15.2857 18.0714C15.2857 19.0571 16.0857 19.8571 17.0714 19.8571H40.6571C41.6286 19.8571 42.4286 19.0571 42.4286 18.0714C42.4286 17.4142 42.0571 16.7999 41.4714 16.4999L30.1857 10.5571C29.3571 10.1142 28.3571 10.1142 27.5286 10.5571V10.5571Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1396_5040",
    x: 0.183673,
    y: 0.591836,
    width: 58.7755,
    height: 65.6327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.40816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.40816
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1396_5040"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.40816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.40816
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1396_5040",
    result: "effect2_dropShadow_1396_5040"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1396_5040",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1396_5040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2857,
    height: 34.2857,
    fill: "white",
    transform: "translate(12.4286 8.42853)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankMarker);
export default __webpack_public_path__ + "static/media/bank_marker.4374e5aea25e9b47dc1bd90dc3a141e3.svg";
export { ForwardRef as ReactComponent };